import { RoSchoolCourseEnrollmentStatsEntity } from "../../../../meta-data/app-meta-data.service";

export interface SchoolCourseStatEntity extends RoSchoolCourseEnrollmentStatsEntity  { 
    ActiveStudents: number;
    CompletedStudents: number;
    AverageProgress: number;
    AverageCompletionTime: number;
}

export enum SchoolCourseStatAggregateFields {
    ActiveStudents= 'ActiveStudents',
    CompletedStudents= 'CompletedStudents',
    AverageProgress= 'AverageProgress',
    AverageCompletionTime = 'AverageCompletionTime',
    AverageProgressDays = 'AverageProgressDays',
    StandardDevisionProgressDays = 'StandardDevisionProgressDays',
    AverageLearningTimePerDay = 'AverageLearningTimePerDay',
    StandardDevisionLearningTimePerDay = 'StandardDevisionLearningTimePerDay',
}